<template>
  <div class="typebar-wrap">
    <ul class="typebar" ref="typebar">
      <li :style="{color: selectTypeIndex === index ? activeColor : color, 'border-color': bdColor}" :class="{active: selectTypeIndex === index}" v-for="(item, index) in typeList" @click="selectItem(item, index)">{{item.name}}</li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      typeList: {
        type: Array,
        require: true
      },
      selectTypeIndex: {
        type: Number,
        default: null
      },
      clickHandler: {
        type: Function,
        require: true
      },
      color: {
        type: String,
        default: '#dae4ee'
      },
      activeColor: {
        type: String,
        default: '#fffefe'
      },
      bdColor: {
        type: String,
        default: '#60c9c8'
      }
    },
    created () {
      this.getDomeFontSize()
    },
    watch: {
      typeList () {
        this.$nextTick(() => {
          this.calcWidth()
        })
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.calcWidth()
      })
    },
    methods: {
      calcWidth () {
        let list = this.$refs.typebar.children
        let width = 0
        for (let i = 0; i < list.length; i++) {
          let item = list[i]
          let w = Math.ceil(parseFloat(this.getStyle(item, 'width')))
          let margin = Math.ceil(parseFloat(this.getStyle(item, 'marginLeft')))
          width += w + margin * 2
        }
        this.$refs.typebar.style.width = width + 'px'
      },
      getStyle (obj, attr) {
        return obj.currentStyle ? obj.currentStyle[attr] : window.getComputedStyle(obj)[attr]
      },
      getDomeFontSize () {
        let docEl = document.documentElement
        var clientWidth = docEl.clientWidth
        if (!clientWidth) return
        if (clientWidth >= 750) {
          docEl.style.fontSize = '100px'
        } else {
          docEl.style.fontSize = 100 * (clientWidth / 750) + 'px'
        }
      },
      selectItem (item, index) {
        this.$emit('click-handler', item, index)
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'
  .typebar-wrap
    width 100%
    height 100%
    overflow-x auto
    &::-webkit-scrollbar
      height 0

  .typebar
    margin 0
    padding 0
    height px2rem(84px)
    min-width 100%
    li
      display inline-block
      font-size px2rem(26px)
      line-height px2rem(26px)
      padding px2rem(26px) 0
      margin 0 px2rem(16px)
      color #9CA5AE
      font-weight bold
      &.active
        border-bottom-width px2rem(6px)
        border-bottom-style solid
        color #275482
</style>



// WEBPACK FOOTER //
// typebar.vue?bd3cf184